import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

interface Props {
  /** tag */
  tag: string;
  /** wrap */
  wrap: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AppWrapper',
  props: {
    tag: null,
    wrap: { type: Boolean }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (__props.wrap)
    ? (_openBlock(), _createBlock(_resolveDynamicComponent(__props.tag), { key: 0 }, {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }))
    : _renderSlot(_ctx.$slots, "default", { key: 1 })
}
}

})